<div id="dynamicPlacemarkContainer">
  @for (item of dynamicPlacemarks; track item) {
    @if (item.placemark.visualizationMethod == 'table') {
      <ins-webgl-dynamic-placemark-table [visible]="true" [placemark]="item.placemark" [properties]="item.properties"></ins-webgl-dynamic-placemark-table>
    }
    @if (item.placemark.visualizationMethod == 'piechart') {
      <ins-webgl-dynamic-placemark-pie [visible]="true" [placemark]="item.placemark" [properties]="item.properties"></ins-webgl-dynamic-placemark-pie>
    }
  }
  @if (dynamicPMOnHover && dynamicPMOnHover.placemark.visualizationMethod == 'table') {
    <ins-webgl-dynamic-placemark-table class="hover" [visible]="dynamicPMOnHover.visible" [placemark]="dynamicPMOnHover.placemark" [properties]="dynamicPMOnHover.properties"></ins-webgl-dynamic-placemark-table>
  }
  @if (dynamicPMOnHover && dynamicPMOnHover.placemark.visualizationMethod == 'piechart') {
    <ins-webgl-dynamic-placemark-pie class="hover" [visible]="dynamicPMOnHover.visible" [placemark]="dynamicPMOnHover.placemark" [properties]="dynamicPMOnHover.properties"></ins-webgl-dynamic-placemark-pie>
  }
</div>
